export default __webpack_public_path__ + "static/media/preview-image(3).b251696a.png";